import "particles.js"

export default function floatingParticles() {
    // eslint-disable-next-line no-undef
    particlesJS(
        "particles",
        {
            particles: {
                number: { value: 200 },
                color: { value: "#ffffff" },
                shape: { type: "circle" },
                opacity: { value: 0.5, random: true },
                size: { value: 36, random: true },
                line_linked: { enable: false },
                move: { enable: true, speed: 1 },
            },
            interactivity: {
                detect_on: "canvas",
                events: {
                    onhover: { enable: false },
                    onclick: { enable: false },
                    resize: true,
                },
            },
            retina_detect: true,
        },
    )
}
